<template>
  <div>
    <p class="header"> Results: Anchoring effect</p>
    <Instructions
    />
    
    <div class="groups">Group A gave a <u>{{ multiply }}x higher price</u> than group B! <p>&<br>You personally priced the hotel room <u>€{{ difference }} {{ lower }}</u> than the other group.</p></div>
    <br>
    <h3>This is how the two groups scored:</h3>
    <div class="button">
      <bg-bar-chart
        v-if="!isLoading"
        :groupA="groupA"
        :groupB="groupB"
        :yourPrice="guess"
        :total="total"
        :group="price === 5000 ? 'Group A' : 'Group B'"
      />
      <bg-loader v-if="isLoading" dark="true" />
    </div>
    
    <hr>  
    <div class="button">Learn more about neuromarketing & sign up for our new experiments & updates:</div>
    <div class="flex">
      <div class="email-container" v-if="unsubscribed">
        <bg-input
          class="input"
          name="email"
          v-model="email"
          placeholder="ex@braingineers.com"
        />
        <bg-button
          v-if="unsubscribed"
          @click="subscribeToEmail"
          text="Signup"
          :isLoading="isEmailLoading"
        ></bg-button>
      </div>
      <div class="button" v-if="!unsubscribed">
        Congratulations, you are subscribed. Check your email for an explanation
        of our experiment!
      </div>
      <div class="share-container">
        <bg-button variant="secondary" @click="openLinkedin" text="Share on LinkedIn"></bg-button>
        <bg-button @click="openFacebook" variant="secondary" text="Share on Facebook"></bg-button>
      </div>
    </div>
    <br>
    <hr>
    <br>
    <img src="@/assets/logo.svg" alt="logo braingineers" class="logo">
    <br>
    <u><a href="https://www.braingineers.com" target="_blank">Learn more about Braingineers</a></u> <br>

  </div>
</template>

<style scoped>

h3 {
  margin-bottom: 10px;
  margin-top: 30px;
}

.margins {
  margin-bottom: 30px;
}

.groups {
  background-color: #F1C40F;
  padding: 25px;
  font-size: 15pt;
  font-weight: 600;
  margin-top: 25px;
}

.flex {
  max-width: 600px;
  margin: auto;
}
.email-container {
  display: flex;
  flex-grow: 1;
  margin-bottom: 20px;
}
.share-container {
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 20px;
}
.button {
  margin: 20px 0;
}
.input {
  width: 100%;
  margin-right: 40px;
}
.header {
  margin-bottom: 40px;
  font-size: 28px;
  font-weight: bold;
}
.paragraph {
  margin-bottom: 10px;
}

.logo {
  width: 40px; 
}
</style>

<script>
import Instructions from "../components/Instructions.vue"
import BgButton from "../components/bg-button";
import BgInput from "../components/bg-input";
import BgBarChart from "../components/bg-bar-chart";
export default {
  name: "App",
  components: {
    BgButton,
    BgBarChart,
    BgInput,
    Instructions
  },
  data() {
    return {
      unsubscribed: true,
      res: null,
      isEmailLoading: false,
      isLoading: false,
      email: "",
    };
  },
  methods: {
    subscribeToEmail() {
      this.isEmailLoading = true;
      fetch("/.netlify/functions/addToCampaign", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ email: this.email })
      })
        .then(response => response.json())
        .then(data => {
          this.unsubscribed = false;
          this.res = data;
        })
        .catch(error => {
          this.res = error;
          this.unsubscribed = false;
          this.isEmailLoading = false;
        });
    },
    openLinkedin() {
      window.open(
        "http://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2Fexperiments.braingineers.com%2F&title=I%20just%20did%20this%20online%20psychological%20experiment%20and%20was%20blown%20away%20by%20the%20true%20power%20of%20our%20subconsciousness.%20Try%20it!",
        "_blank"
      );
    },
    openFacebook() {
      window.open(
        "https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fexperiments.braingineers.com%2F",
        "_blank"
      );
    }
  },
  computed: {
    price() {
      return this.$store.state.price;
    },
    guess() {
      return this.$store.state.guess;
    },
    groupA() {
      return this.$store.state.groupA;
    },
    groupB() {
      return this.$store.state.groupB;
    },
    total() {
      return this.$store.state.total;
    },
    difference() {
      if (this.price === 5000) {
        return this.guess - this.groupA
      } else {
        return this.groupB - this.guess
      }
    },
    multiply() {
      return Math.round(this.groupB / this.groupA)
    },
    lower() {
      if (this.price === 5000) {
        return 'higher'
      } else {
        return 'lower'
      }
    }
  }
};
</script>
